var module = angular.module('main.customerorder');

module.component('caCustomerOrderRefunds',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerorderrefunds.cmp.tpl.html',
    bindings: {
        customerOrder: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate) {
    var vm = this;

    //Properties
    vm.customerOrder = {};

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getTotalRefundQuantity = getTotalRefundQuantity;
    vm.getTotalRefundAmount = getTotalRefundAmount;
    vm.getTotalQuantityOfAllRefunds = getTotalQuantityOfAllRefunds;
    vm.getTotalAmountOfAllRefunds = getTotalAmountOfAllRefunds;

    function onInit() {
    }
    function onChanges() {
    }

    function getTotalRefundQuantity(refund) {
        var sum = _.sumBy(refund.rows, function(o) { return o.quantity; });
        return sum;
    }
    function getTotalRefundAmount(refund) {
        var sum = _.sumBy(refund.rows, function(o) { return o.amount; });
        return sum;
    }

    function getTotalQuantityOfAllRefunds() {
        var sum = _.sumBy(vm.customerOrder.refunds, function(o) {
            return _.sumBy(o.rows, function(o2) {
                return o2.quantity;
            });
        });
        return sum;
    }

    function getTotalAmountOfAllRefunds() {
        var sum = _.sumBy(vm.customerOrder.refunds, function(o) {
            return _.sumBy(o.rows, function(o2) {
                return o2.amount;
            });
        });
        return sum;
    }
}
